import ScrollMagic from 'scrollmagic';

const Gallery = () => {
  const controller = new ScrollMagic.Controller();

  const galleries = document.querySelectorAll('.page-section-gallery');

  if (!galleries.length) return;

  galleries.forEach(gallery => {
    new ScrollMagic.Scene({ triggerElement: gallery })
      .setClassToggle(gallery, "active")
      .addIndicators({ name: 'panel content' })
      .addTo(controller);
  });
};

export default Gallery;